import Widgets from "@/pages/widgets";
import Features from "@/pages/home/features";
import { getTimeOfDay } from "@/lib/date-utils";
import useUserInfo from "@/hooks/use-user-info";
import SystemWidgets from "./system-widget";
import Footer from "@/pages/components/footer";

export default function HomePage() {
  const userInfo = useUserInfo();
  const currentDate = new Date();

  return (
    <div className="mb-0 flex h-[calc(100vh-64px)] min-w-[320px] flex-col justify-between overflow-hidden overflow-y-auto bg-slate-100 px-12 py-4">
      <div className="flex flex-col gap-5">
        {/*
          1.3.1 Info and Relationships — A / 2.4.6 Headings and Labels — AA. This was a
          <Label> — a <label> element with no associated control — so the page had no
          heading for a screen reader user to navigate to. It is the page's primary
          heading; the classes are unchanged so it renders identically.
        */}
        <h1 className="my-4 overflow-visible text-2xl font-medium leading-none text-primary">
          Good {getTimeOfDay(currentDate)}! {userInfo.firstname}{" "}
          {userInfo.lastname}
        </h1>
        <Features />
        <SystemWidgets />
        <Widgets />
      </div>
      <div className="w-full items-end">
        <Footer />
      </div>
    </div>
  );
}
